export default "__VITE_ASSET__CuFhLVsB__"